import Field from "../../../components/shared/Field/Field";
import { autosave, formatAmount, weeksToMilliseconds } from "../../../util";
import appState from "../../../state/AppStateContainer";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value: string | number | undefined,
  projectSlug: string,
  rowData: {
    areaId: {
      slug: string,
    },
    purchaseCompleted: Date | undefined,
    productionStartsAt: Date | undefined,
  },
  onBlur: (value: string | number | undefined) => Promise<void>,
  isLeadTime?: boolean,
  onFocusStylesEnabled?: boolean,
  label?: string,
  className: string,
  unit?: string,
  style?: React.CSSProperties
}

const TableField: FC<Props> = ({ label, value, onBlur, isLeadTime, onFocusStylesEnabled = true, className, unit, style }) => {
  const [t] = useTranslation('projects', { keyPrefix: 'purchaseList.tableField' });
  if (!unit) unit = t('fallbackPriceUnit', 'kr');

  const fieldValue = value ? formatAmount(value) : (value === 0 ? '0' : '');

  const [editValue, setEditValue] = useState<string | undefined>(fieldValue);
  useEffect(() => {
    setEditValue(fieldValue);
  }, [fieldValue]);

  return appState.isReadOnlyAccessRole() && !label ? (
    fieldValue &&
      <span style={{ whiteSpace: 'nowrap' }}>
        {fieldValue} {isLeadTime ? t('weekUnit', 'veckor', { count: typeof value === 'number' ? Math.abs((value)) : 0 }) : unit}
      </span>
  ) : (
    <Field
      label={label}
      style={{ minWidth: '150px', textAlign: "right", paddingRight: 0, ...style }}
      className={className}
      onFocusStylesEnabled={onFocusStylesEnabled}
      onClick={e => e.stopPropagation()}
      value={editValue}
      disabled={appState.isReadOnlyAccessRole()}
      unit={isLeadTime ? t('weekUnit', 'veckor', { count: typeof value === 'number' ? Math.abs((value)) : 0 }) : unit}
      onChange={value => setEditValue(formatAmount(value))}
      onBlur={async e => {
        let tempValue: string | number | undefined;
        if (isLeadTime) {
          tempValue = weeksToMilliseconds(e.target.value);
          setEditValue(e.target.value);
        } else {
          tempValue = formatAmount(e.target.value);
          setEditValue(tempValue?.toString());
        }
        if (onBlur) {
          autosave(async () => {
            await onBlur(tempValue);
          });
        }
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key == "Enter") {
          e.currentTarget.blur();
          e.preventDefault();
        } else if (e.key == "Escape") {
          e.currentTarget.value = fieldValue;
          e.currentTarget.blur();
          e.preventDefault();
        }
      }}
    />
  )
}

export default TableField;
